import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/display.css';
import 'element-ui/lib/theme-chalk/index.css';
import './style/index.scss';
import 'animate.css';// animate 动画
// require ('./mock/index')// 运行mock
Vue.use(ElementUI);
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
    let desc = document.querySelector('meta[name="description"]');
    if (desc) {
      desc.setAttribute('content', to.meta.description || '宇起数字，专注智能指纹密码器、智能指纹柜锁、售后服务。');
    }
  }
  next();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
